import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
})
export class SignupComponent implements OnInit {
  givenName = '';
  familyName = '';
  email = '';
  password = '';
  error: string | null = null;
  loading = false;

  private returnUrl: string | null = null;

  constructor(
    private readonly auth: AuthService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
  }

  async onSubmit(): Promise<void> {
    this.error = null;
    this.loading = true;
    try {
      await this.auth.signUp(this.email, this.password, this.givenName, this.familyName);
      const queryParams: Record<string, string> = { email: this.email };
      if (this.returnUrl) queryParams['returnUrl'] = this.returnUrl;
      await this.router.navigate(['/confirm-signup'], { queryParams });
    } catch (err: unknown) {
      this.error = err instanceof Error ? err.message : 'Sign-up failed. Please try again.';
    } finally {
      this.loading = false;
    }
  }
}
